(function AdzukiAlert($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['close'],
		props: {
			show : Boolean,
			title: {
				type   : String,
				default: 'Success'
			},
			type: {
				type     : String,
				default  : 'success',
				validator: value => ['success', 'error', 'warning', 'info'].includes(value),
			},
			message: {
				type   : String,
				default: 'The action was completed successfully.'
			},
		},
		computed: {
			themeBg() {
				switch (this.type) {
					case 'success':
						return 'bg-alert-success';
					case 'error':
						return 'bg-alert-error';
					case 'warning':
						return 'bg-alert-warning';
					case 'info':
						return 'bg-alert-info';
					default:
						return 'bg-alert-success';
				}
			},
			themeIcon() {
				switch (this.type) {
					case 'success':
						return 'fas fa-check-circle';
					case 'error':
						return 'fas fa-exclamation-circle';
					case 'warning':
						return 'fas fa-exclamation-triangle';
					case 'info':
						return 'fas fa-info-circle';
					default:
						return 'fas fa-check-circle';
				}
			},
			themeBtn() {
				switch (this.type) {
					case 'success':
						return 'btn-primary';
					case 'error':
						return 'btn-danger';
					case 'warning':
						return 'btn-warning';
					case 'info':
						return 'btn-info';
					default:
						return 'btn-primary';
				}
			}
		},
		methods: {
			closeAlert() {
				this.$emit('close');
			}
		},
		template: `
			<teleport to="body">
				<div v-if="show" class="alert-overlay" @click="closeAlert">
					<div class="alert-dialog rounded rounded-1 p-1" :class="themeBg" @click.stop>
						<div class="alert-dialog__header fw-bold p-3 fs-4">
							<span class="alert-dialog__title">
								<i :class="themeIcon" aria-hidden="true"></i>
								{{ title }}
							</span>
						</div>
						<div class="alert-dialog__body mb-3 px-3 text-break" v-html="message"></div>
						<div class="alert-dialog__footer p-2 text-end">
							<button type="button" class="btn rounded me-1" :class="themeBtn" @click="closeAlert">OK</button>
						</div>
					</div>
				</div>
			</teleport>
		`,
	};

	Adzuki.VueComponents.AdzukiAlert = component;
}(jQuery, window.Adzuki || {}));
